import { Alert, Typography } from '@mui/material';

type Props = {
  title: string;
  description?: string;
};

export function PlaceholderSection({ title, description }: Props) {
  return (
    <div>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Alert severity="info">
        {description ||
          'This section mirrors the commercial.nextres flow and will be connected as backend rules firm up.'}
      </Alert>
    </div>
  );
}
